import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

interface ScenarioQueryParams {
	companyId: string;
	businessId: string;
}

export const scenarioApi = createApi({
	reducerPath: 'scenarioApi',
	baseQuery: fetchBaseQuery({ baseUrl: '/api' }),
	endpoints: builder => ({
		fetchScenario: builder.query<any, ScenarioQueryParams>({
			query: ({ companyId, businessId }) => ({
				url: `/scenarios/${companyId}/${businessId}`,
				method: 'GET',
			}),
		}),
	}),
});

export const { useFetchScenarioQuery } = scenarioApi;
